import { useState, useCallback } from "react";
import apiBooking from "../../redux2/booking/apiBooking";

const useRefunds = () => {
  const [refunds, setRefunds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchRefunds = useCallback(
    async ({
      searchTerm = "",
      status = "",
      startDate = "",
      endDate = "",
    } = {}) => {
      setLoading(true);
      setError(null);
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user || !user.token) throw new Error("User not authenticated.");
        const res = await apiBooking.getHalfRefund(
          user.token,
          searchTerm,
          status,
          startDate,
          endDate
        );
        setRefunds(res.data);
      } catch (err) {
        setError(err.message || "Failed to fetch refunds.");
        console.error("Fetch error:", err);
      } finally {
        setLoading(false);
      }
    },
    []
  );

  const updateRefundStatus = async (bookingId, newStatus) => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user || !user.token) throw new Error("User not authenticated.");

      const res = await apiBooking.updateHalfRefundStatus(
        user.token,
        bookingId
      );

      if (res.success) {
        setRefunds((prev) => ({
          ...prev,
          bookings: prev?.bookings?.map((r) =>
            r?._id === bookingId ? { ...r, status: newStatus } : r
          ),
        }));

        return { success: true };
      } else {
        return { success: false, message: res.message };
      }
    } catch (err) {
      console.error("Update error:", err);
      return { success: false, message: "Failed to update status." };
    }
  };

  const refundBooking = async (bookingId) => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user || !user.token) throw new Error("User not authenticated.");
      const res = await apiBooking.refundHalfBooking(user.token, bookingId);

      if (res.success) {
        setRefunds((prev) => ({
          ...prev,
          bookings: prev?.bookings?.map((r) =>
            r?._id === bookingId ? { ...r, status: "refund-done" } : r
          ),
        }));
        window.location.reload();
        return { success: true };
      } else {
        return { success: false, message: res.message };
      }
    } catch (err) {
      console.error("Refund error:", err);
      return { success: false, message: "Failed to refund booking." };
    }
  };

  return {
    refunds,
    loading,
    error,
    updateRefundStatus,
    refundBooking,
    fetchRefunds,
  };
};

export default useRefunds;
